export function ExtraResourceRelic({
	relicCount,
	leftSide,
	icon = '/liveGameIcons/unique/oliveRelics.png',
}) {
	return (
		<div
			className="flex flex-row w-[84px] h-[40px] justify-center border-solid border"
			style={{
				backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
				borderColor: 'var(--main-color)',
			}}
		>
			<div className="flex flex-col text-right gap-1">
				<div className="flex flex-row justify-center items-center h-4 mt-1 -mb-1">
					<h1 className="text-white text-lg">
						{parseInt(relicCount)}
					</h1>
					<h1 className="text-[#b1b1b1] italic text-sm">/3</h1>
				</div>
				<div className="h-3 text-[#b1b1b1] italic text-xs">
					{parseInt(80 * relicCount)}/min
				</div>
			</div>
			<img className="h-8" src={`${icon}`} alt="" />
		</div>
	)
}
